<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="fixed z-50 inset-0 overflow-y-auto" @close="open = false">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-8/12 sm:p-6">
                        <code-types-list class="mt-8" @changed="typeWasChange" :selected-type="type"></code-types-list>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>

import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/24/outline'
import CodeTypesList from "../CodeTypesList.vue";
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckIcon,
        Location,
        CodeTypesList
    },

    mounted() {
        this.emitter.on("toggle-qr-code-type-modal", (destinationId) => {
            this.open = true
            this.destinationId = destinationId
        });
    },

    data() {
        return {
            open: false,
            destinationId: null
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code']),
        type: {
            get() {
                return this.code.destinations[this.destinationId].type
            }
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateDestinationType', 'updateDestinationData']),

        typeWasChange(data) {
            this.open = false
            this.updateDestinationType(this.destinationId, data.type)
            this.updateDestinationData(this.destinationId, data.fields)
        }
    },
}
</script>
